import { assert } from '@fe/core';
import { EventBus } from '../../contexts/event-bus';
import { createDrawingObject, deleteDrawingObject, drawingObjectsSlice, updateDrawingObject } from '../slices/drawing-objects-slice';
import { startAppListening } from './listener-middleware';
import { DrawingObject } from '../../../components/drawing-object/types';

export function startDrawingObjectListener() {
    startAppListening({
        actionCreator: drawingObjectsSlice.actions.initDrawingObjects,
        effect: (action) => {
            EventBus.fire('drawing-objects-updated', {
                updated: [],
                deleted: [],
                added: action.payload,
                objectsToDisableFpmSync: []
            });
        }
    });

    startAppListening({
        actionCreator: drawingObjectsSlice.actions.updateDrawingObjects,
        effect: (action, api) => {
            const original = api.getOriginalState().drawingObjects.objects;

            const removeFromSync = action.payload.deleted
                .map((id) => original.find((x) => x.id === id))
                .filter((x) => x?.fpmProperties.sync) as DrawingObject[];

            const updatedNotToSync = action.payload.updated
                .map((update) => ({
                    previous: original.find((x) => x.id === update.id),
                    new: update
                }))
                .filter((x) => x.previous?.fpmProperties.sync && !x.new.fpmProperties.sync)
                .map((x) => x.new);

            removeFromSync.push(...updatedNotToSync);

            EventBus.fire('drawing-objects-updated', {
                updated: action.payload.updated.filter((update) => original.some((x) => x.id === update.id)),
                deleted: action.payload.deleted,
                added: action.payload.updated.filter((update) => !original.some((x) => x.id == update.id)),
                objectsToDisableFpmSync: removeFromSync.map((x) => x.id)
            });
        }
    });

    startAppListening({
        actionCreator: createDrawingObject.fulfilled,
        effect: (action, api) => {
            if (!action.payload.success) {
                return;
            }
            const state = api.getState();
            const object = state.drawingObjects.objects.find((x) => x.id === action.payload.object!.id);
            assert(object); // can't be null here because it's just been created
            EventBus.fire('drawing-objects-updated', {
                updated: [],
                deleted: [],
                added: [object],
                objectsToDisableFpmSync: []
            });
        }
    });

    startAppListening({
        actionCreator: updateDrawingObject.fulfilled,
        effect: (action, api) => {
            if (!action.payload.success) {
                return;
            }

            const original = api.getOriginalState().drawingObjects.objects.find((x) => x.id === action.meta.arg.id);

            EventBus.fire('drawing-objects-updated', {
                updated: [action.meta.arg],
                deleted: [],
                added: [],
                objectsToDisableFpmSync: original?.fpmProperties.sync && !action.meta.arg.fpmProperties.sync ? [action.meta.arg.id] : []
            });
        }
    });

    startAppListening({
        actionCreator: deleteDrawingObject.fulfilled,
        effect: (action, api) => {
            if (!action.payload.success) {
                return;
            }

            const object = api.getOriginalState().drawingObjects.objects.find((x) => x.id === action.meta.arg);
            EventBus.fire('drawing-objects-updated', {
                updated: [],
                deleted: [action.meta.arg],
                added: [],
                objectsToDisableFpmSync: object?.fpmProperties.sync ? [object.id] : []
            });
        }
    });
}
